import { Result } from 'antd';
import * as React from 'react';
import * as z from 'zod';

import { TipIcon } from '@components/common';
import * as E from '@utils/errors';

export interface ErrorTipProps {
  error?: Error;
}

const getErrorTitle = (error?: Error) => {
  if (error instanceof E.StatusQueryError) return error.message;

  if (error instanceof z.ZodError) return `ConfigValidateError`;

  return error?.name || 'Error';
};

const getErrorContent = (error?: Error) => {
  if (error instanceof E.StatusQueryError) return '';
  if (error instanceof z.ZodError) {
    return `failed to parse configuration...`;
  }

  return error?.message || 'Some errors occurred...';
};

export const ErrorTip = React.memo(({ error }: ErrorTipProps) => (
  <Result
    status="error"
    icon={<TipIcon type="error" />}
    title={getErrorTitle(error)}
    subTitle={getErrorContent(error)}
  />
));
